import { useContext } from 'react';

import { TaskDetailContext } from './task-detail-context';

export const useActiveTaskId = () => {
  const context = useContext(TaskDetailContext);
  return context.activeTaskId;
};
